import config from '@/config';
import api from '@/shared/api';
import { useMutation, useQueryClient } from '@tanstack/react-query';
import { useIntl } from 'react-intl';
import handleHttpError from '@/shared/services/HandleHttpError';
import { findTaskById, updateTask } from '@/shared/utils/infiniteDataHelper';
import { TaskQueryKey } from './queryKey';
const updateTaskDeadline = (oldData, newData) => {
    if (!newData)
        return oldData;
    const newValue = Object.assign(Object.assign({}, oldData), { deadline: newData.deadline });
    const mainTask = newValue;
    const newMainTask = newData;
    if (!(mainTask === null || mainTask === void 0 ? void 0 : mainTask.children))
        return newValue;
    if (!(newMainTask === null || newMainTask === void 0 ? void 0 : newMainTask.children))
        return newValue;
    mainTask.children = mainTask.children.map(c => {
        const newChild = newMainTask.children.find(y => y.id === c.id);
        if (!newChild)
            return c;
        return Object.assign(Object.assign({}, c), { deadline: newChild.deadline });
    });
    return mainTask;
};
export const useUpdateTaskDeadline = () => {
    const intl = useIntl();
    const queryClient = useQueryClient();
    const { mutateAsync, isLoading, error } = useMutation(values => {
        var _a;
        return api.base
            .put(`${config.appUrls.tasks}/api/plannedTasks/deadline/${values.id}/${(_a = values.deadline) === null || _a === void 0 ? void 0 : _a.format('YYYY-MM-DD')}`, null, {
            params: {
                taskLevel: values.taskLevel,
            },
        })
            .then(res => res.data);
    }, {
        onMutate: async (taskToUpdate) => {
            // Cancel any outgoing refetches
            // (so they don't overwrite our optimistic update)
            await queryClient.cancelQueries({ queryKey: [TaskQueryKey.PlannedTasks] });
            const currentData = queryClient.getQueryData([TaskQueryKey.PlannedTasks]);
            const result = findTaskById(currentData, taskToUpdate.id);
            if (result) {
                queryClient.setQueryData([TaskQueryKey.PlannedTasks], (oldData) => updateTask(oldData, taskToUpdate.id, x => (Object.assign(Object.assign({}, x), { deadline: taskToUpdate.deadline }))));
            }
            return { previousTask: result === null || result === void 0 ? void 0 : result.task };
        },
        onSuccess: (data) => {
            queryClient.setQueryData([TaskQueryKey.PlannedTasks], (oldData) => updateTask(oldData, data.id, x => updateTaskDeadline(x, data)));
        },
        onError: (e, taskToUpdate, context) => {
            queryClient.setQueryData([TaskQueryKey.PlannedTasks], (oldData) => updateTask(oldData, taskToUpdate.id, x => updateTaskDeadline(x, context === null || context === void 0 ? void 0 : context.previousTask)));
            handleHttpError(intl)(e);
        },
    });
    return {
        updateTaskDeadline: mutateAsync,
        isLoading,
        error,
    };
};
